var map = {
	"./en/role-1/r-1-1-icon.png": "VVcS",
	"./en/role-1/r-1-2-icon.png": "tWnm",
	"./en/role-1/r-1-3-icon.png": "19st",
	"./en/role-1/r-1-4-icon.png": "Zpc7",
	"./en/role-1/r-1-5-icon.png": "+t2k",
	"./en/role-2/r-2-1-icon.png": "1Xfb",
	"./en/role-2/r-2-2-icon.png": "82Uk",
	"./en/role-2/r-2-3-icon.png": "YNFZ",
	"./en/role-2/r-2-4-icon.png": "TfJO",
	"./en/role-3/r-3-1-icon.png": "dcEJ",
	"./en/role-3/r-3-2-icon.png": "3+Bh",
	"./en/role-3/r-3-3-icon.png": "xZ3k",
	"./en/role-3/r-3-4-icon.png": "GcDW",
	"./en/role-4/r-4-1-icon.png": "xgpo",
	"./en/role-4/r-4-2-icon.png": "kEHJ",
	"./en/role-4/r-4-3-icon.png": "Fikr",
	"./en/role-4/r-4-4-icon.png": "+zGl",
	"./en/role-4/r-4-5-icon.png": "hLuG",
	"./en/role-5/r-5-1-icon.png": "hbcj",
	"./en/role-5/r-5-2-icon.png": "wFt5",
	"./en/role-5/r-5-3-icon.png": "Q65j",
	"./en/role-5/r-5-4-icon.png": "KDGw"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qZRn";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3 ^\.\/.*\-icon\.png$
// module id = qZRn
// module chunks = 0